import type { OrderGroupId } from "@@/shared/order-groups/order-group-id";
import type {
    PaymentProvider} from "@@/shared/payments/payment-providers";
import {
    paymentProviderZodSchema,
} from "@@/shared/payments/payment-providers";
import type { UserId} from "@@/shared/users/user-id";
import { userIdZodSchema } from "@@/shared/users/user-id";
import type { UUID } from "@@/shared/uuid";
import { z } from "zod";
import type { OrderId } from "../order-id";
import {
    _orderStatusBaseFactory,
    _orderStatusBaseZodSchema,
} from "./_order-status-base";
import { orderStatusType } from "./order-status-types";

const orderStatusPaymentFulfilledZodSchema = _orderStatusBaseZodSchema.merge(
    z.object({
        type: z.literal(orderStatusType.PAYMENT_FULFILLED),
        createdBy: userIdZodSchema.or(z.string()),
        paymentUUID: z.string() as unknown as z.ZodType<UUID>,
        paidAmount: z.number().min(0),
        paymentProvider: paymentProviderZodSchema,
    }),
);
type OrderPaymentFulfilled = z.infer<
    typeof orderStatusPaymentFulfilledZodSchema
>;

const orderStatusPaymentFulfilledFactory = (params: {
    readonly orderId: OrderId;
    readonly orderGroupId: OrderGroupId;
    readonly createdBy: UserId | string;
    readonly paymentUUID: UUID;
    readonly paymentProvider: PaymentProvider;
    readonly paidAmount: number;
}): OrderPaymentFulfilled => ({
    ..._orderStatusBaseFactory(params.orderId, params.orderGroupId),
    type: "PAYMENT_FULFILLED",
    createdBy: params.createdBy,
    paymentUUID: params.paymentUUID,
    paymentProvider: params.paymentProvider,
    paidAmount: params.paidAmount,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isOrderPaymentFulfilled = (item: any): item is OrderPaymentFulfilled => {
    return item.type === "PAYMENT_FULFILLED";
};

export {
    isOrderPaymentFulfilled,
    orderStatusPaymentFulfilledFactory,
    orderStatusPaymentFulfilledZodSchema,
};
export type { OrderPaymentFulfilled };
